import React, { useEffect } from 'react';

const DiditCallback: React.FC = () => {
  useEffect(() => {
    console.log('DiditCallback cargado. URL:', window.location.href);
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status') || '';
    const verificationSessionId = params.get('verificationSessionId') || '';

    console.log('Params detectados:', { status, verificationSessionId });

    const payload = {
      type: 'didit-result',
      status,
      verificationSessionId,
    };

    try {
      // Usamos '*' para asegurar que el mensaje llegue independientemente del origen en desarrollo
      if (window.opener) {
        console.log('Enviando mensaje a window.opener');
        window.opener.postMessage(payload, '*');
      }

      if (window.parent && window.parent !== window) {
        console.log('Enviando mensaje a window.parent');
        window.parent.postMessage(payload, '*');
      }
    } catch (err) {
      console.error('Error enviando postMessage:', err);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600 mb-4"></div>
      <p className="text-gray-600 text-sm font-medium">Finalizando verificación...</p>
      <p className="text-gray-400 text-xs mt-2">Por favor espera, cerrando ventana.</p>
    </div>
  );
};

export default DiditCallback;

